import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class ComparisonModal extends Component {
  // METHOD TO CONVERT NUMERIC STATUS TO LOW/MED/HIGH VALUE
  metricStatus = (value) => {
    let loggedValue;
    if (value > 0.666) {
      loggedValue = "high";
    } else if (value > 0.333) {
      loggedValue = "medium";
    } else {
      loggedValue = "low";
    }

    return loggedValue;
  }

  // METHOD TO CONVERT DURATION TO MINUTES
  durationToMinutes = (duration) => {
    const minutes = Math.round(duration / 60000);
    const seconds = Math.round((duration - (minutes * 60000)) / 1000);
    let finalSeconds;
    let finalMinutes;
    if (seconds < 0) {
      finalSeconds = seconds + 60;
      finalMinutes = minutes - 1;
    } else {
      finalSeconds = seconds;
      finalMinutes = minutes;
    }

    if (finalSeconds < 10) {
      finalSeconds = `0${finalSeconds}`
    }

    const finalDuration = `${finalMinutes}:${finalSeconds}`;

    return finalDuration;
  }

  // METHOD TO CONVERT KEY AND MODE TO PITCH CLASS NOTATION
  pitchClassNotation = (key, mode) => {
    const pitchClass = [
      "C",
      "C♯/D♭",
      "D",
      "D♯/E♭",
      "E",
      "F",
      "F♯/G♭",
      "G",
      "G♯/A♭",
      "A",
      "A♯/B♭",
      "B"
    ]

    const activeKey = pitchClass[key];
    let activeMode;

    if (mode === 0) {
      activeMode = "minor";
    } else {
      activeMode = "major";
    }

    const activeScale = `${activeKey} ${activeMode}`;

    return activeScale;
  }

  // METHOD TO CONVERT TEMPO TO BEATS PER MINUTE
  tempoToBPM = (tempo) => {
    const roundedTempo = Math.round(tempo);
    const tempoString = `${roundedTempo} bpm`
    return tempoString;
  }

  // METHOD TO SHORTEN STRING
  shorten = (string) => {
    let truncStr = '';
    if (string.length > 20) {
      truncStr = `${string.substring(0, 15)}...`;
    } else {
      truncStr = string;
    }
    return truncStr;
  }

  // RENDER
  render() {
    return (
      <div>
        <div className="modal comparisonModal">
          <div id="showComparison" onClick={this.props.showModal} className="exitModal">
            <FontAwesomeIcon icon="times" className="icon" />
          </div>
          <h2>Compare songs</h2>
          <div className="container">
            {/* User song details */}
            {[this.props.userSong, this.props.recommendedSong].map(song => {
              return (
                <div className="songDetails" key={song.songId}>
                  <img src={song.albumImg} alt={song.albumName} className="albumImg" />
                  <h3>{song.songName}</h3>
                  <h3 className="artistName">{song.artistNames.map((artist, i) => {
                    return <span>{artist}{((i + 1) < song.artistNames.length) && ", "}</span>
                  })}</h3>
                  <h3><span className="albumName">{this.shorten(song.albumName)}</span> <span className="albumYear">({song.albumYear})</span></h3>
                  <div className="spotify-link-container">
                    <a href={song.externalURL} target="_blank" rel="noopener noreferrer" className="spotify-link">
                      <FontAwesomeIcon icon={['fab', 'spotify']} className="icon" />
                      <p>Open</p>
                    </a>
                  </div>
                  <div className="parameter-metrics">
                    <p className={(this.props.parameters[0].checked === false) && 'parameter-unchecked'}><span className="parameter-name">Danceability</span><span className="parameter-value">{this.metricStatus(song.features.danceability)}</span></p>
                    <p className={(this.props.parameters[1].checked === false) && 'parameter-unchecked'}><span className="parameter-name">Duration</span><span className="parameter-value">{this.durationToMinutes(song.features.duration)}</span></p>
                    <p className={(this.props.parameters[2].checked === false) && 'parameter-unchecked'}><span className="parameter-name">Energy</span><span className="parameter-value">{this.metricStatus(song.features.energy)}</span></p>
                    <p className={(this.props.parameters[3].checked === false) && 'parameter-unchecked'}><span className="parameter-name">Key</span><span className="parameter-value">{this.pitchClassNotation(song.features.key, song.features.mode)}</span></p>
                    <p className={(this.props.parameters[4].checked === false) && 'parameter-unchecked'}><span className="parameter-name">Tempo</span><span className="parameter-value">{this.tempoToBPM(song.features.tempo)}</span></p>
                    <p className={(this.props.parameters[5].checked === false) && 'parameter-unchecked'}><span className="parameter-name">Valence</span><span className="parameter-value">{this.metricStatus(song.features.valence)}</span></p>
                  </div>
                </div>)
            })}

          </div>
        </div>
        )
      }
        <div className="modalBackground"></div>
      </div >
    )
  }
}


  export default ComparisonModal;
